function camelCase(src: string): string {
    return src.split("-").map((word, index) => {
        if (!word.length) {
            return "";
        }
        if (index) {
            return word[0].toUpperCase() + word.substring(1).toLowerCase();
        } else {
            return word.toLowerCase();
        }
    }).join("");
}

function coerce(raw: string, type: "string" | "boolean" | "number") {
    if (type === "string") {
        return raw;
    }
    if (type === "boolean") {
        return raw === "TRUE";
    }
    if (type === "number") {
        return parseFloat(raw);
    }
    return raw;
}

export function parseEnv<T>(src: Record<string, string>): T {
    return Object.keys(src)
        .reduce<T>((acc, key) => {
            let targetKey = key;
            let type: "string" | "boolean" | "number" = "string";
            if (key.endsWith("-FLAG")) {
                targetKey = key.substring(0, key.length - 5);
                type = "boolean";
            } else if (key.endsWith("-MSEC")) {
                targetKey = key.substring(0, key.length - 5);
                type = "number";
            }
            const args = targetKey.split("_").map(camelCase);
            let obj = acc;
            while (args.length > 1) {
                const sub = args.shift();
                if (typeof obj === "object") {
                    if (!obj[sub]) {
                        obj[sub] = {};
                    }
                    obj = obj[sub];
                }
            }
            if (typeof obj === "object") {
                obj[args.shift()] = coerce(src[key], type);
            }

            return acc;
        }, {} as T);
}